import Registered from '../Registered';

export default {
    'registered': Registered,
};
